import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
function usePrevious(value) {
  const ref = useRef(null);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
export const RouteChangeListener = t0 => {
  const $ = _c(8);
  const {
    onChange,
    shouldFireOnInit: t1,
    shouldFireOnAnchorChange: t2
  } = t0;
  const shouldFireOnInit = t1 === undefined ? false : t1;
  const shouldFireOnAnchorChange = t2 === undefined ? false : t2;
  const location = useLocation();
  const previousPathname = usePrevious(location.pathname);
  const previousHash = usePrevious(location.hash);
  let t3;
  let t4;
  if ($[0] !== location || $[1] !== onChange || $[2] !== previousHash || $[3] !== previousPathname || $[4] !== shouldFireOnAnchorChange || $[5] !== shouldFireOnInit) {
    t3 = () => {
      const isInit = !previousPathname;
      const canTrackPathname = !isInit || shouldFireOnInit;
      if (canTrackPathname && previousPathname !== location.pathname || shouldFireOnAnchorChange && previousHash !== location.hash) {
        onChange(location, location.hash);
      }
    };
    t4 = [shouldFireOnInit, shouldFireOnAnchorChange, location, onChange, previousHash, previousPathname];
    $[0] = location;
    $[1] = onChange;
    $[2] = previousHash;
    $[3] = previousPathname;
    $[4] = shouldFireOnAnchorChange;
    $[5] = shouldFireOnInit;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  return null;
};
export default RouteChangeListener;